import React, { createContext, useContext, useState } from "react";

// Context oluştur
const FacilityContext = createContext();

// Context kullanımı için custom hook
export const useFacility = () => {
  return useContext(FacilityContext);
};

// Provider bileşeni
export const FacilityProvider = ({ children }) => {
  const [facility, setFacility] = useState(null); // Başlangıç değeri null

  return (
    <FacilityContext.Provider value={{ facility, setFacility }}>
      {children}
    </FacilityContext.Provider>
  );
};
